import { WorkerApiService } from "./worker";

import type { paths } from "../../__definitions__/self-driving.changeengine.com-definitions";
import type { Workers } from "../../utils/service-url";
import type { ApiResponse } from "./client";

export type MultiformatPhotos =
  paths["/multiformat/{formatId}/photos"]["post"]["responses"]["200"]["content"]["application/json"];

export type MultiformatIcons =
  paths["/multiformat/{formatId}/icons"]["post"]["responses"]["200"]["content"]["application/json"];

export type MultiformatVideos =
  paths["/multiformat/{formatId}/videos"]["post"]["responses"]["200"]["content"]["application/json"];

type MultiformatTextRequest =
  paths["/multiformat/{formatId}/text"]["post"]["requestBody"]["content"]["application/json"];

export class SelfDrivingService extends WorkerApiService {
  module = "self-driving" as const satisfies Workers;

  async photos(
    formatId: string,
    description: string,
    gptModel?: "ga" | "alpha",
    industry?: string,
    fileId?: string,
    db?: string,
  ): Promise<ApiResponse<{ photos: MultiformatPhotos["photos"] }>> {
    const settings = new URLSearchParams();
    if (gptModel) settings.set("model", gptModel);

    return await this.post(`multiformat/${formatId}/photos?${settings.toString()}`, {
      description,
      industry,
      fileId,
      ...(db && { db }),
    });
  }

  async icons(
    formatId: string,
    description: string,
    fileId?: string,
    gptModel?: "ga" | "alpha",
  ): Promise<ApiResponse<{ icons: MultiformatIcons["icons"] }>> {
    const settings = new URLSearchParams();
    if (gptModel) settings.set("model", gptModel);

    return await this.post(`multiformat/${formatId}/icons?${settings.toString()}`, {
      description,
      fileId,
    });
  }

  async videos(
    formatId: string,
    description: string,
    fileId?: string,
    gptModel?: "ga" | "alpha",
  ): Promise<ApiResponse<MultiformatVideos>> {
    const settings = new URLSearchParams();
    if (gptModel) settings.set("model", gptModel);

    return await this.post(`multiformat/${formatId}/videos?${settings.toString()}`, {
      description,
      fileId,
    });
  }

  async text(
    formatId: string,
    request: MultiformatTextRequest,
    gptModel?: "ga" | "alpha",
  ): Promise<
    ApiResponse<{
      text: string;
    }>
  > {
    const settings = new URLSearchParams();
    if (gptModel) settings.set("model", gptModel);

    return await this.post(`multiformat/${formatId}/text?${settings.toString()}`, request);
  }
}
